module.exports = __webpack_public_path__ + "img/img8.b79d5098.png";